<div class="flex gap-2 justify-end">
  <app-pan-button color="primary" icon="add" (click)="params.addCallback()" matTooltip="Add API Key"></app-pan-button>
</div>
